export const catalog_matrix = [
    {form_key:'responsible_id', catalog_key:'none', propname:'users'},
    {form_key:'proceadure_id',catalog_key:'proceadures'}
]